module.exports = __webpack_public_path__ + "img/水果特工队1.2343b5f0.png";